export const FIRST_COLUMN = 0;
export const SECOND_COLUMN = 1;
